import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  rendezVousPart5WeekColumn,
  rendezVousPart5WeekColumnLessOpacity,
  rendezVousPart5WeekDate,
  rendezVousPart5WeekDateJour,
  rendezVousPart5WeekDateJourNombre,
  rendezVousPart5WeekDateMois,
  rendezVousPart5CreneauxDispos,
  rendezVousPart5CreneauxSubContainer,
  rendezVousPart5CreneauxCollapsed,
} from "./rendez-vous-part-5.module.scss"
import {
  RendezVousPart5WeekDate,
  RendezVousPart5WeekDateJourNombre,
  RendezVousPart5CreneauxDispos,
  RendezVousPart5CreneauxDisposChoisi,
} from "../rendez-vous-styled.js"
import Icon from "../../Icon/icon"

export const RendezVousPart5DayColumn = ({
  jour,
  creneauxDisponibles,
  changeWeekOffset,
  changeCreneau,
  creneauChoisi,
}) => {
  const [collapsed, setCollapsed] = useState(true)
  const [width, setWidth] = useState(window.innerWidth)
  const date = new Date(jour + "T00:00")
  const options = {
    weekday: "long",
    day: "numeric",
    month: "long",
  }
  const labelJour = Intl.DateTimeFormat("fr-FR", options).format(date)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  return (
    <div
      className={
        creneauxDisponibles.creneaux.length > 0
          ? rendezVousPart5WeekColumn
          : rendezVousPart5WeekColumnLessOpacity
      }
    >
      <RendezVousPart5WeekDate
        onClick={() => setCollapsed(!collapsed)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            setCollapsed(!collapsed)
          }
        }}
        tabIndex={
          creneauxDisponibles.creneaux.length > 0 && width < 900 ? 0 : -1
        }
        className={rendezVousPart5WeekDate}
        role={
          creneauxDisponibles.creneaux.length && width < 900 ? "button" : null
        }
        aria-expanded={width < 900 ? !collapsed : null}
        aria-label={width < 900 ? labelJour : null}
      >
        <p className={rendezVousPart5WeekDateJour}>
          {creneauxDisponibles.jourLabel}
        </p>
        <RendezVousPart5WeekDateJourNombre
          className={rendezVousPart5WeekDateJourNombre}
        >
          {creneauxDisponibles.jourNombre}
        </RendezVousPart5WeekDateJourNombre>
        <p className={rendezVousPart5WeekDateMois}>
          {creneauxDisponibles.moisLabel}
        </p>
        <p>
          {collapsed ? (
            <Icon size={45} icon="chevron-thin-down"></Icon>
          ) : (
            <Icon size={45} icon="chevron-thin-up"></Icon>
          )}
        </p>
      </RendezVousPart5WeekDate>
      <div
        htmlFor={jour}
        className={`${rendezVousPart5CreneauxSubContainer} ${
          collapsed ? rendezVousPart5CreneauxCollapsed : ""
        }`}
      >
        {creneauxDisponibles.creneaux.map((heure, indexHeure) => {
          const dateCreneau = new Date(jour + "T" + heure)

          const dateOptions = {
            weekday: "long",
            day: "numeric",
            month: "long",
            hour: "2-digit",
            minute: "2-digit",
          }

          // Formatter avec Intl.DateTimeFormat
          let labelCreneau = new Intl.DateTimeFormat("fr-FR", dateOptions)

          labelCreneau = labelCreneau.format(dateCreneau)
          if (creneauChoisi === jour + " " + heure) {
            return (
              <RendezVousPart5CreneauxDisposChoisi
                key={heure}
                className={rendezVousPart5CreneauxDispos}
                onClick={() => changeCreneau("")}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    changeCreneau("")
                  }
                }}
                tabIndex={0}
                aria-label={labelCreneau + " - Créneau séléctionné"}
              >
                {heure}
              </RendezVousPart5CreneauxDisposChoisi>
            )
          }
          return (
            <RendezVousPart5CreneauxDispos
              key={heure}
              className={rendezVousPart5CreneauxDispos}
              onClick={() => changeCreneau(jour + " " + heure)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  changeCreneau(jour + " " + heure)
                }
              }}
              tabIndex={0}
              role={"button"}
              aria-label={labelCreneau}
            >
              {heure}
            </RendezVousPart5CreneauxDispos>
          )
        })}
      </div>
    </div>
  )
}

RendezVousPart5DayColumn.propTypes = {
  jour: PropTypes.string,
  creneauxDisponibles: PropTypes.object,
  changeWeekOffset: PropTypes.func,
  changeCreneau: PropTypes.func,
  creneauChoisi: PropTypes.string,
  step: PropTypes.number,
}
